import { render, staticRenderFns } from "./ScreenLaudoNeurosonografia.vue?vue&type=template&id=67cb13f5&lang=true&"
import script from "./ScreenLaudoNeurosonografia.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoNeurosonografia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports